/**
 * Build-time env. Vite only exposes vars prefixed `VITE_*` to the client.
 *
 * Both values are used as URL PREFIXES — the api client appends paths like
 * `/me`, `/csrf`, `/entities`, etc., and Better-Auth appends `/sign-in`, etc.
 * So the env value MUST include the `/api` (and `/api/auth`) suffix.
 *
 * In dev: leave both unset → falls back to the Vite proxy at /api (same-origin).
 * In prod (CF Pages):
 *   VITE_API_URL=https://api.dissregarded.app/api
 *   VITE_AUTH_URL=https://auth.dissregarded.app/api/auth
 *
 * Set in `apps/web/.env.production.local` (gitignored — keep in sync with the
 * CF Pages env vars if the project is git-connected). Don't drop the suffix:
 * Better-Auth rejects relative paths with "Invalid base URL", and the api
 * client constructs `${API_URL}/me` which 404s on the bare origin.
 */
export const env = {
  API_URL: import.meta.env.VITE_API_URL ?? "/api",
  AUTH_URL: import.meta.env.VITE_AUTH_URL ?? "/api/auth",
};
